"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _dept = require("_a/admin/dept/dept");
var _message = require("_l/message");
var _vuex = require("vuex");
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _vueTreeselect2 = _interopRequireDefault(require("@riophae/vue-treeselect"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'dept-manage',
  components: {
    TablePage: _tablePage.default,
    VueTreeselect: _vueTreeselect2.default
  },
  data: function data() {
    return {
      columns: [{
        label: '部门名称',
        prop: 'name',
        width: '300',
        align: 'left'
      }, {
        label: '排序',
        prop: 'deptSort'
      }, {
        label: '联系电话',
        prop: 'phone'
      }, {
        label: '邮箱',
        prop: 'email'
      }, {
        label: '部门状态',
        slot: 'deptStatus'
      }, {
        label: '操作',
        slot: 'action'
      }],
      queryParams: {},
      dialogShow: false,
      dialogTitle: '添加部门',
      statusOptionList: [],
      form: {},
      rules: {
        name: [this.$ruler('部门名称')],
        deptSort: [this.$ruler('显示顺序')],
        deptStatus: [this.$ruler('部门状态')]
      },
      deptTree: [],
      normalizer: function normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        };
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 添加弹出框
     */
    addDept: function addDept() {
      this.dialogTitle = '添加部门';
      this.deptTree.length = 0;
      this.deptTree.unshift({
        id: 0,
        name: '顶级公司',
        parentIds: 0,
        children: this.$refs.tablePage.data
      });
      this.form = {
        deptStatus: '0',
        deptSort: 10
      };
      this.dialogShow = true;
    },
    /**
     * 修改弹出框
     * @param row
     */
    update: function update(row) {
      this.form = _objectSpread({}, row);
      this.deptTree.length = 0;
      this.deptTree.unshift({
        id: 0,
        name: '顶级公司',
        parentIds: 0,
        children: this.$refs.tablePage.data
      });
      this.dialogTitle = '修改部门';
      this.dialogShow = true;
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _dept.deleteDeptById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this.refresh();
        });
      });
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this2.dialogTitle === '添加部门') {
            (0, _dept.addDept)(_this2.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('add');
              } else {
                (0, _message.MessageError)('add');
              }
              _this2.cancelDialogAndRefresh();
            });
          } else {
            (0, _dept.updateDept)(_this2.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('upd');
              } else {
                (0, _message.MessageError)('upd');
              }
              _this2.cancelDialogAndRefresh();
            });
          }
        }
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      // 清空表单
      this.handleReset('form');
      // 刷新表格
      this.refresh();
    },
    treeSelect: function treeSelect(node, instanceId) {
      if (node.ancestors !== 0) {
        this.form.ancestors = node.ancestors + ',' + node.id;
      } else {
        this.form.ancestors = node.id;
      }
    }
  }),
  mounted: function mounted() {
    var _this3 = this;
    this.getDictListByType('dept_status').then(function (res) {
      _this3.statusOptionList = res;
    });
  }
};